import { c as _c } from "react/compiler-runtime";
import { useControlledSwr } from '@systemeio/util';
import { FilterPageFormApiInterface } from 'modules/automation-rules/types/automation-rule-filter-interface';
import { FormSelectDataType } from 'shared/components';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
export const usePageForms = (pageId, t0) => {
  const $ = _c(8);
  const shouldFetch = t0 === undefined ? true : t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const t2 = `/api/dashboard/page-editor/page/${pageId}/forms`;
  let t3;
  if ($[1] !== t2) {
    t3 = [t2, RequestModuleEnum.Websites];
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    data: pageFormList,
    isLoading: isPageFormListLoading
  } = useControlledSwr(t3, fetcher, undefined, shouldFetch && !!user && !!pageId);
  let t4;
  if ($[3] !== pageFormList) {
    t4 = pageFormList?.map(_temp);
    $[3] = pageFormList;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const pageFormData = t4;
  let t5;
  if ($[5] !== isPageFormListLoading || $[6] !== pageFormData) {
    t5 = {
      pageFormData,
      isPageFormListLoading
    };
    $[5] = isPageFormListLoading;
    $[6] = pageFormData;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
function _temp(el) {
  return {
    id: el.id,
    caption: el.name
  };
}